
// import React, { useEffect } from 'react';
// import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
// import Login from './register/Login';
// import Register from './register/Registration';
// import Dashboard from './dashboard';
// import AddBookType from "./components/Add_Book_Type/AddBookType";
// import AddNewBook from "./components/Add_New_Book/AddNewBook";
// import BookList from "./components/Book_List/BookList";
// import IssueBook from "./components/Issue_Book/IssueBook";
// import IssuedBookList from './components/Issued_Book_List/IssuedBookList';
// import IssueBookForStaff from './components/Issue_Book_Staff/IssueBookStaff';
// import IssuedBookForStaffList from './components/Issued_Book_List_Staff/IssuedBookListStaff';
// import AddLibrary from './components/Library_List/LibraryList';
// import TransactionBookList from './components/Transaction_Book_List/TransactionBookList';
// import DiscardedBookList from './components/Discarded_Book_List/DiscardedBookList';
// import BooksBarcode from './components/Books_Barcode/BooksBarcode';
// import SpineLabel from './components/Spine_Label/SpineLabel';
// import AddNewspaper from './components/Add_Newspaper/AddNewspaper';
// import BookRecord from './components/Book_Record/BookRecord';
// import BookNameList from "./components/New_Arrivals/NewArrivals";
// import ClasswiseBookList from './components/Classwise_Book_List/ClasswiseBookList';
// import HistoryOfBooks from './components/History_of_Books/HistoryOfBooks';
// import MembersHistory from './components/History_of_Members/MembersHistory';
// import IssueBookUsingScanner from './components/Issue_Book_Using_Scanner/IssueBookUsingScanner';
// import NewArrivals from "./components/New_Arrivals/NewArrivals";
// import NewspaperRegister from './components/Newspaper_Register/NewspaperRegister';
// import PeriodicalManagement from './components/Periodical_Management/PeriodicalManagement';
// import VerifyBooks from './components/Verify_Books/VerifyBooks';
// import StaffLayout from "./StaffLayout/Stafflayout"; // Import Layout
// import Staff from "./components/Staff/Staff"
// import ParentDashboard from './Parents/ParentsDashboard';
// import ParentIssueBook from './Parents/ParentIssueBook.js';
// // ... other component imports
// import Layout from './Layout/Layout'; // 👈 your layout that includes Sidebar
// import { AuthProvider } from './Constant/Auth.js';
// import ParentBookList from './Parents/BookList.js';
// import AddAnnouncement from './components/AddAnnouncement/AddAnnouncement.js';
// import AnnouncementList from './components/AddAnnouncement/AnnouncementList.js';

// // Li
// import LibrarianDashboard from './Librarian/LibrarianDashboard';
// import Lib_AddNewBook from './Librarian/Add_New_Book/Lib_AddNewBook.js'
// import LibrarianAddBookType from './Librarian/Add_Book_Type/Librarian_AddBookType.js';
// import Lib_AnnouncementList from './Librarian/AddAnnouncement/Lib_AnnouncementList.js'
// import Lib_AddAnnouncement from './Librarian/AddAnnouncement/Lib_AddAnnouncement.js'
// import Lib_BookList from './Librarian/Book_List/Lib_BookList.js'
// import Lib_MembersHistory from './Librarian/History_of_Members/Lib_MembersHistory.js'
// import Lib_IssuedBookList from './Librarian/Issued_Book_List/Lib_IssuedBookList.js'
// import Lib_Transaction_BookList from './Librarian/Transaction_Book_List/Lib_TransactionBookList.js'
// //import PrivateRoute from './register/protected'

// function App() {
//   const roleId = localStorage.getItem('roleId');
//   const libraryId = localStorage.getItem('libraryId');
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isLoggedIn = () => roleId && libraryId;

//   useEffect(() => {
//     if (!isLoggedIn() && location.pathname !== '/login' && location.pathname !== '/register') {
//       navigate('/login');
//     }
//   }, [location]);

//   return (
//     <AuthProvider>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />

//         {/* All protected routes under Sidebar layout */}
//         <Route element={<Layout />}>
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/add-book-type" element={<AddBookType />} />
//           <Route path="/add-new-book" element={<AddNewBook />} />
//           <Route path="/book-list" element={<BookList />} />
//           <Route path="/issue-book" element={<IssueBook />} />
//           <Route path="/issued-book-list" element={<IssuedBookList />} />
//           <Route path="/issue-book-for-staff" element={<IssueBookForStaff />} />
//           <Route path="/issued-book-for-staff-list" element={<IssuedBookForStaffList />} />
//           <Route path="/library-list" element={<AddLibrary />} />
//           <Route path="/transaction-book-list" element={<TransactionBookList />} />
//           <Route path="/discarded-book-list" element={<DiscardedBookList />} />
//           <Route path="/books-barcode" element={<BooksBarcode />} />
//           <Route path="/spine-label" element={<SpineLabel />} />
//           <Route path="/book-record" element={<BookRecord />} />
//           <Route path="/book-name-list" element={<BookNameList />} />
//           <Route path="/new-arrivals" element={<NewArrivals />} />
//           <Route path="/add-newspaper" element={<AddNewspaper />} />
//           <Route path="/newspaper-register" element={<NewspaperRegister />} />
//           <Route path="/periodical-management" element={<PeriodicalManagement />} />
//           <Route path="/members-history" element={<MembersHistory />} />

//           {/* parents api */}
//           <Route path="/parent-dashboard" element={<ParentDashboard />} />
//           <Route path="/parent-issue-book" element={<ParentIssueBook/>} />
//           <Route path="/parent-book-list" element={<ParentBookList/>} />
//           <Route path="/add-announcement" element={<AddAnnouncement />} />
//           <Route path="/announcements" element={<AnnouncementList />} />

//           {/* Librarian */}
//           <Route path="/librarian/dashboard" element={<LibrarianDashboard />} />
//           <Route path="/librarian/add-new-book" element={<Lib_AddNewBook/>}/>
//           <Route path="/librarian/add-book-type" element={<LibrarianAddBookType />} />
//           <Route path="/librarian/book-list" element={<Lib_BookList/>}/>
//           <Route path="/librarian/announcementcreate" element={<Lib_AddAnnouncement/>}/>
//           <Route path="/librarian/announcementlist" element={<Lib_AnnouncementList/>}/>
//           <Route path="/librarian/members-history" element={<Lib_MembersHistory/>}/>
//           <Route path="/librarian/issued-book-list" element={<Lib_IssuedBookList/>}/>
//           <Route path="/librarian/transaction-book-list" element={<Lib_Transaction_BookList/>}/>
          
          
          
//         </Route>
//       </Routes>
//     </AuthProvider>
//   );
// }

// export default App;

// import React, { useEffect } from 'react';
// import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
// import Login from './register/Login';
// import Register from './register/Registration';
// import Dashboard from './dashboard';
// import AddBookType from "./components/Add_Book_Type/AddBookType";
// import AddNewBook from "./components/Add_New_Book/AddNewBook";
// import BookList from "./components/Book_List/BookList";
// import IssueBook from "./components/Issue_Book/IssueBook";
// import IssuedBookList from './components/Issued_Book_List/IssuedBookList';
// import IssueBookForStaff from './components/Issue_Book_Staff/IssueBookStaff';
// import IssuedBookForStaffList from './components/Issued_Book_List_Staff/IssuedBookListStaff';
// import AddLibrary from './components/Library_List/LibraryList';
// import TransactionBookList from './components/Transaction_Book_List/TransactionBookList';
// import DiscardedBookList from './components/Discarded_Book_List/DiscardedBookList';
// import BooksBarcode from './components/Books_Barcode/BooksBarcode';
// import SpineLabel from './components/Spine_Label/SpineLabel';
// import AddNewspaper from './components/Add_Newspaper/AddNewspaper';
// import BookRecord from './components/Book_Record/BookRecord';
// import BookNameList from "./components/New_Arrivals/NewArrivals";
// import ClasswiseBookList from './components/Classwise_Book_List/ClasswiseBookList';
// import HistoryOfBooks from './components/History_of_Books/HistoryOfBooks';
// import MembersHistory from './components/History_of_Members/MembersHistory';
// import IssueBookUsingScanner from './components/Issue_Book_Using_Scanner/IssueBookUsingScanner';
// import NewArrivals from "./components/New_Arrivals/NewArrivals";
// import NewspaperRegister from './components/Newspaper_Register/NewspaperRegister';
// import PeriodicalManagement from './components/Periodical_Management/PeriodicalManagement';
// import VerifyBooks from './components/Verify_Books/VerifyBooks';
// import StaffLayout from "./StaffLayout/Stafflayout"; // Import Layout
// import Staff from "./components/Staff/Staff"
// import ParentDashboard from './Parents/ParentsDashboard';
// import ParentIssueBook from './Parents/ParentIssueBook.js';
// // ... other component imports
// import Layout from './Layout/Layout'; // 👈 your layout that includes Sidebar
// import { AuthProvider } from './Constant/Auth.js';
// import ParentBookList from './Parents/BookList.js';
// import AddAnnouncement from './components/AddAnnouncement/AddAnnouncement.js';
// import AnnouncementList from './components/AddAnnouncement/AnnouncementList.js';

// // Li
// import LibrarianDashboard from './Librarian/LibrarianDashboard';
// import Lib_AddNewBook from './Librarian/Add_New_Book/Lib_AddNewBook.js'
// import LibrarianAddBookType from './Librarian/Add_Book_Type/Librarian_AddBookType.js';
// import Lib_AnnouncementList from './Librarian/AddAnnouncement/Lib_AnnouncementList.js'
// import Lib_AddAnnouncement from './Librarian/AddAnnouncement/Lib_AddAnnouncement.js'
// import Lib_BookList from './Librarian/Book_List/Lib_BookList.js'
// import Lib_MembersHistory from './Librarian/History_of_Members/Lib_MembersHistory.js'
// import Lib_IssuedBookList from './Librarian/Issued_Book_List/Lib_IssuedBookList.js'
// import Lib_Transaction_BookList from './Librarian/Transaction_Book_List/Lib_TransactionBookList.js'
// import PrivateRoute from './PrivateRoute.js'


// function AppRoutes() {
//   return (
//     <Routes>
//       {/* Public routes */}
//       <Route path="/" element={<Login />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/register" element={<Register />} />

//       {/* Private/protected routes */}
//       <Route element={
//         <PrivateRoute>
//           <Layout />
//         </PrivateRoute>
//       }>
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/add-book-type" element={<AddBookType />} />
//         <Route path="/add-new-book" element={<AddNewBook />} />
//         <Route path="/book-list" element={<BookList />} />
//         <Route path="/issue-book" element={<IssueBook />} />
//         <Route path="/issued-book-list" element={<IssuedBookList />} />
//         <Route path="/issue-book-for-staff" element={<IssueBookForStaff />} />
//         <Route path="/issued-book-for-staff-list" element={<IssuedBookForStaffList />} />
//         <Route path="/library-list" element={<AddLibrary />} />
//         <Route path="/transaction-book-list" element={<TransactionBookList />} />
//         <Route path="/discarded-book-list" element={<DiscardedBookList />} />
//         <Route path="/books-barcode" element={<BooksBarcode />} />
//         <Route path="/spine-label" element={<SpineLabel />} />
//         <Route path="/book-record" element={<BookRecord />} />
//         <Route path="/book-name-list" element={<BookNameList />} />
//         <Route path="/new-arrivals" element={<NewArrivals />} />
//         <Route path="/add-newspaper" element={<AddNewspaper />} />
//         <Route path="/newspaper-register" element={<NewspaperRegister />} />
//         <Route path="/periodical-management" element={<PeriodicalManagement />} />
//         <Route path="/members-history" element={<MembersHistory />} />
//         <Route path="/add-announcement" element={<AddAnnouncement />} />
//         <Route path="/announcements" element={<AnnouncementList />} />

//         {/* Parent */}
//         <Route path="/parent-dashboard" element={<ParentDashboard />} />
//         <Route path="/parent-issue-book" element={<ParentIssueBook />} />
//         <Route path="/parent-book-list" element={<ParentBookList />} />

//         {/* Librarian */}
//         <Route path="/librarian/dashboard" element={<LibrarianDashboard />} />
//         <Route path="/librarian/add-new-book" element={<Lib_AddNewBook />} />
//         <Route path="/librarian/add-book-type" element={<LibrarianAddBookType />} />
//         <Route path="/librarian/book-list" element={<Lib_BookList />} />
//         <Route path="/librarian/announcementcreate" element={<Lib_AddAnnouncement />} />
//         <Route path="/librarian/announcementlist" element={<Lib_AnnouncementList />} />
//         <Route path="/librarian/members-history" element={<Lib_MembersHistory />} />
//         <Route path="/librarian/issued-book-list" element={<Lib_IssuedBookList />} />
//         <Route path="/librarian/transaction-book-list" element={<Lib_Transaction_BookList />} />
//       </Route>
//     </Routes>
//   );
// }

// function App() {
//   return (
//     <AuthProvider>
//       <AppRoutes />
//     </AuthProvider>
//   );
// }

// export default App;


// App.js
import React from 'react';
import { AuthProvider } from './Constant/Auth';
import AppRoutes from './AppRoutes'; // 👈 Import it here

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;



